import React from 'react';
import { Breakdown as ReportBreakdownShape } from '../../shapes/report';

class ReportBreakdownItem extends React.Component {

  render() {
    return (
      <React.Fragment>
        <tr>
          <td>{this.props.breakdown.hardMeter ? '* ' : ''}{this.props.breakdown.name}</td>
          <td>{this.props.breakdown.in}</td>
          <td>{this.props.breakdown.paid}</td>
          <td>{this.props.breakdown.net}</td>
          <td>{this.props.breakdown.tax}</td>
        </tr>
      </React.Fragment>
    )
  }

}

ReportBreakdownItem.propTypes = {
  breakdown: ReportBreakdownShape.isRequired
};

export default ReportBreakdownItem;


// WEBPACK FOOTER //
// ./src/views/report/report-breakdown-item.js